module.exports = __webpack_public_path__ + "static/palitaw-d5f05449080146ba9b4716d68fe026dd.jpg";